const s=()=>null,t=s=>s.ctrlKey||s.shiftKey;export{t as c,s as n};
//# sourceMappingURL=utils-9fe19391.js.map
